module.exports = __webpack_public_path__ + "img/contents_goodstore@2x.a0ed2f26.png";